import axios from 'axios';

class WhmcsApi {
  constructor(apiUrl) {
    this.apiUrl = process.env.REACT_APP_API_URL;
    this.signal = null;
  }

  async request(type, params, method = 'POST', token = null) {
    try {
      // Construye los encabezados opcionales
      const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
      };

      // Agrega el token de autorización si está presente
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      const config = {
        method,
        url: this.apiUrl,
        headers,
        withCredentials: true
      };

      // si existe signal, se agrega a las configuraciones
      if(this.signal){
        config.signal = this.signal
      }

      if (method === 'GET') {
        config.params = { type, ...params, responsetype: 'json' };
      } else {
        config.data = new URLSearchParams({ type, ...params, responsetype: 'json' }).toString();
      }

      const response = await axios(config);
      return response.data;
    } catch (error) {
      console.error(`Error fetching data for type ${type}:`, error);
      throw error;
    }
  }

  /**
   * @see https://axios-http.com/docs/cancellation
   * @see https://developer.mozilla.org/en-US/docs/Web/API/AbortController
   * @param {AbortController.signal} signal 
   */
  setSignal(signal){
    this.signal = signal;
  }
}

export default WhmcsApi;
